<template>
	<div class="about-us-wrapper">
		<div class="content">
			<div class="main">
				<div class="introduce-content">關於<span>LOOPSHOP</span></div>
				<div class="tips">了解 LOOPSHOP 直播短片網店系統各個方案和支援功能，找到您的業務最佳方案</div>
				<div class="left">
					<!-- <img src="" alt=""> -->
				</div>
				<div class="right">
					<!-- <img src="" alt=""> -->
				</div>
			</div>
		</div>
		<div class="introduce-wrapper main">
			<div class="introduce-left">
				<!-- <div class="conter">
					<div class="introduce-about">關於</div>
					<div class="introduce-img"><img src="@/assets/images/registerLogin.png" alt=""></div>
				</div> -->
				<div class="introduce-content"> <span>LOOPSHOP</span>{{ aboutData.toptitle1 }}</div>
				<div class="introduce-title">
					{{ aboutData.toptitle2 }}</div>
			</div>
		</div>
		<Brand></Brand>
		<div class="suitability-wrapper ">
			<div class="introduce-section">
				<div class="section-title">{{ aboutData.title }}</div>
				<div class="section-conten"> {{ aboutData.detail }}
				</div>
				<!-- <div class="section-substance">LOOPSHOP致力協助中小企商戶數碼轉型，讓他們以APP應用程式或網站系統輕鬆設立屬於自己的直播短片網店！</div> -->
			</div>
			<div class="image-grid">
				<div class="image-row">
					<div class="image-item">
						<div class="img-box"><img :src="aboutData.image1" alt=""></div>
						<div class="title">{{ aboutData.title1 }}</div>
					</div>
					<div class="image-item">
						<div class="img-box"><img :src="aboutData.image2" alt=""></div>
						<div class="title">{{ aboutData.title2 }}</div>
					</div>
				</div>
				<div class="image-row">
					<div class="image-item">
						<div class="img-box"><img :src="aboutData.image3" alt=""></div>
						<div class="title">{{ aboutData.title3 }}</div>
					</div>
					<div class="image-item">
						<div class="img-box"><img :src="aboutData.image4" alt=""></div>
						<div class="title">{{ aboutData.title4 }}</div>
					</div>
				</div>
			</div>
		</div>
		<AdBox></AdBox>
		<Start></Start>
	</div>
</template>
<script>
import Brand from '@/components/Brand.vue'
import Start from '@/components/Start.vue'
import AdBox from '@/components/AdBox.vue'
export default {
	components: { Brand, Start, AdBox },
	data() {
		return {
			aboutData: []
		}

	},
	mounted() {

		this.getAboutData()

	},
	methods: {

		async getAboutData() {
			let fdata = { do: 'getset', goto: 'aboutusset', limit: 15 }
			let res = await this.$api.funk(fdata)
			this.aboutData = res
		},


	}

}
</script>
<style lang="scss" scoped>
.about-us-wrapper {
	.introduce-wrapper {
		display: flex;
		margin-top: 0.8rem;
		margin-bottom: 2.15rem;
		justify-content: center;
		align-items: center;

		.introduce-left {
			.conter {
				display: flex;
				align-items: center;

				.introduce-about {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.72rem;
					line-height: 1.01rem;
					letter-spacing: 0.02em;
					color: #000000;
				}

				.introduce-img {
					width: 1.88rem;
					height: 0.87rem;

					img {
						width: 100%;
						height: 100%;
						display: block;
					}
				}
			}

			.introduce-content {
				width: 7.8rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.4rem;
				line-height: 0.56rem;
				color: #000000;
				margin: 0 0 0.8rem 0;
				text-align: center;

				span {
					color: #E02E43;
				}
			}

			.introduce-title {
				width: 7.8rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.34rem;
				text-align: center;
				color: #000000;

			}
		}

		.introduce-right {
			padding-left: 0.3rem;
			width: 9.28rem;
			height: 6.19rem;

			img {
				width: 100%;
				height: 100%;
				border-radius: 0.3rem;
			}
		}
	}



	.suitability-wrapper {
		background: url('~@/assets/images/about-bg.png')no-repeat center center /100% 100%;
		display: flex;
		justify-content: center;

		.introduce-section {
			.section-title {
				width: 5.18rem;
				height: 0.56rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 600;
				font-size: 0.4rem;
				line-height: 0.56rem;
				color: #E02E43;
				margin-top: 1.80rem;
				margin-bottom: 0.48rem;
			}

			.section-conten {
				width: 6.11rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.34rem;
				color: #000000;
				margin-bottom: 0.32rem;
			}

			.section-substance {
				width: 6.16rem;
				font-family: 'PingFang HK';
				font-style: normal;
				font-weight: 400;
				font-size: 0.24rem;
				line-height: 0.34rem;

				color: #000000;
			}
		}

		.image-grid {
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
			margin-top: 1.25rem;

			.image-row {
				display: flex;
			}

			.image-item {
				display: flex;
				flex-direction: column;
				align-items: center;

				.title {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.2rem;
					line-height: 0.28rem;
					color: #000000;
					margin-top: 0.14rem;
					margin-bottom: 0.37rem;
					text-align: center;
				}


				img {
					width: 2.90rem;
					height: 2.08rem;
					border-radius: 0.1rem;
					margin-left: 0.24rem;
				}
			}
		}
	}

	.content {
		width: 100%;
		height: 4.2rem;
		background: url('~@/assets/images/banner/aboutus.png')no-repeat center center /100% 100%;
		position: relative;
		background-size: cover;

		.left {
			width: 4.53rem;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.main {
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
			flex-direction: column;
		}


		.right {
			width: 4.53rem;
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.introduce-content {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.64rem;
			line-height: 0.64rem;
			color: #000000;
			text-align: center;

			span {
				color: #E02E43;
			}
		}

		.tips {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			text-align: center;
			color: #000000;
			margin-top: 0.16rem;
		}
	}


}


@media (max-width: 750px) {
	.about-us-wrapper .introduce-wrapper .introduce-left .introduce-content {
		width: 100%;
	}

	.introduce-left {
		width: 100%;
	}

	.about-us-wrapper .introduce-wrapper .introduce-left .introduce-title {
		width: 100%;
		font-size: 0.28rem;
		line-height: 0.38rem;
	}

	.about-us-wrapper .suitability-wrapper {
		display: block;
	}

	.introduce-section {
		width: 100%;

	}

	.about-us-wrapper .suitability-wrapper .introduce-section .section-title {
		width: 100%;
		text-align: center;
		margin-top: 0;
		padding-top: 1.8rem;
		height: auto;
		font-size: 0.42rem;
		line-height: 0.42rem;
	}

	.about-us-wrapper .suitability-wrapper .introduce-section .section-conten {
		width: 100%;
		text-align: center;
		padding: 0 0.4rem;
		font-size: 0.28rem;
		line-height: 0.38rem;
	}

	.about-us-wrapper .suitability-wrapper .introduce-section .section-substance {
		width: 100%;
		text-align: center;
		padding: 0 0.4rem;
		font-size: 0.28rem;
		line-height: 0.38rem;
	}

	.about-us-wrapper .suitability-wrapper .image-grid .image-row {
		align-items: center;
		justify-content: space-between;
	}

	.about-us-wrapper .suitability-wrapper .image-grid .image-item img {
		margin-left: 0;
		width: 100%;
		height: 100%;
		display: block;
	}

	.about-us-wrapper .suitability-wrapper .image-grid {
		padding: 0 0.4rem;
	}

	.about-us-wrapper .suitability-wrapper .image-grid .image-item .img-box {
		width: 2.9rem;
		height: 2.08rem;
	}

	.content .left,
	.content .right {
		display: none;
	}

	.about-us-wrapper .content .tips {
		font-size: 0.28rem;
		line-height: 0.38rem;
	}

	.about-us-wrapper .suitability-wrapper .image-grid .image-item .title {
		font-size: 0.26rem;
		line-height: 0.28rem;
	}



}
</style>